import React from 'react';

/** Normalize raw status strings for class keys. */
export function normalizeStatusKey(status) {
  return String(status || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/-/g, '_');
}

/**
 * Map a status value to shared semantic modifier class(es).
 * Returns classes without the base `.rt-status-pill` (add that separately).
 */
export function statusToneClass(status) {
  const key = normalizeStatusKey(status);

  const success = new Set([
    'active',
    'paid',
    'completed',
    'resolved',
    'allocated',
    'success',
    'generated',
    'created',
    'approved',
  ]);
  const danger = new Set([
    'inactive',
    'vacated',
    'cancelled',
    'canceled',
    'failed',
    'ended',
    'allocationended',
    'expired',
    'rejected',
    'disabled',
  ]);
  const warning = new Set([
    'overdue',
    'partially_paid',
    'partial',
    'future',
    'futureallocation',
    'notice',
    'on_notice',
    'open',
    'pending',
    'processing',
    'warning',
    'paused',
  ]);
  const info = new Set([
    'sent',
    'assigned',
    'in_progress',
    'delivered',
    'info',
    'not_generated',
    'imported',
    'system',
  ]);
  const neutral = new Set([
    'draft',
    'none',
    'unknown',
    'closed',
    'custom',
  ]);

  if (success.has(key)) return 'rt-status-active';
  if (danger.has(key)) return 'rt-status-vacated';
  if (warning.has(key)) return 'rt-status-warning';
  if (info.has(key)) return 'rt-status-info';
  if (neutral.has(key)) return 'rt-status-neutral';

  // Prefer specific key class when unknown (e.g. custom statuses)
  return key ? `rt-status-${key}` : 'rt-status-neutral';
}

export function statusPillClass(status, extra = '') {
  return ['rt-status-pill', statusToneClass(status), extra]
    .filter(Boolean)
    .join(' ');
}

export function formatStatusLabel(status) {
  if (status == null || status === '') return 'N/A';
  return String(status)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Shared status pill element. */
export default function RTStatusPill({ status, children, className = '', ...rest }) {
  return (
    <span className={statusPillClass(status, className)} {...rest}>
      {children != null ? children : formatStatusLabel(status)}
    </span>
  );
}
